var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReverse = function SvgReverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.806 3.455A8.25 8.25 0 0 0 4.742 6.1V3.592h-1v4.473h4.473v-1h-2.99a7.273 7.273 0 1 1-1.19 7.321l-.931.366a8.276 8.276 0 0 0 15.975-3.025 8.273 8.273 0 0 0-8.273-8.272"
  })));
};
export default SvgReverse;